export const APP_VERSION = 'v0.02';

export const SUPABASE_URL = 'https://xlqisybphoyonidpompv.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhscWlzeWJwaG95b25pZHBvbXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMDIwNDksImV4cCI6MjA2NTY3ODA0OX0.gLTUZdFFEDq_5IjeGKqI6PwnnVVpkok3VmavR6OrYo8';

export const config = {
  supabaseUrl: 'https://xlqisybphoyonidpompv.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhscWlzeWJwaG95b25pZHBvbXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMDIwNDksImV4cCI6MjA2NTY3ODA0OX0.gLTUZdFFEDq_5IjeGKqI6PwnnVVpkok3VmavR6OrYo8'
}; 